import { motion } from "framer-motion";
import { useTheme } from "../theme/theme-provider";

const Loading = () => {
    const theme = useTheme();

    return (
        <div
            className="flex flex-col items-center justify-center min-h-screen"
            role="status"
            aria-live="polite"
        >
            <motion.div
                className="relative w-16 h-16"
                animate={{ rotate: 360 }}
                transition={{
                    duration: 1,
                    repeat: Infinity,
                    ease: "linear",
                }}
            >
                <div className="absolute w-full h-full border-4 border-gray-200 dark:border-gray-700 rounded-full" />
                <div className="absolute w-full h-full border-4 border-t-primary-500 rounded-full animate-pulse" />
            </motion.div>
            <span className="sr-only">Loading...</span>
        </div>
    );
};

export default Loading;
